import Star from '../../img/star.svg';
const AvisAgence = () => {
    return(
        <div className="container-avis pl-16 min-[320px]:pl-4">
            <div className="container-avis-title">
                <h2 className="text-f-40 font-bold">Vos avis comptent<span>.</span></h2>
            </div>
            <div className="container-avis-blocs">
                <div className="card-avis p-6">
                    <div className="star mb-4">
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                    </div>
                    <p>Nous avons eu l'occasion de rencontrer Simon de Focus production grâce à une vidéo tournée au Château Paloumey pour le site LaDegust.fr. Son professionnalisme et la grande qualité de son travail nous ont convaincus de faire appel à lui pour le lancement de notre nouvelle cuvée sans soufre ajouté. Et nous n'avons pas été déçus ! Simon est réactif, créatif, consciencieux et à l'écoute. Le résultat vidéo est superbe. A suivre…
                    </p>
                    <p className="person mt-4">Château Paloumey</p>
                </div>
                <div className="card-avis p-6">
                    <div className="star mb-4">
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                    </div>
                    <p>Fiable, sérieux et créatif. Un excellent photographe et Videaste que je te recommande
                    </p>
                    <p className="person mt-4">Digit Expert</p>
                </div>
                <div className="card-avis p-6">
                    <div className="star mb-4">
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                    </div>
                    <p>Entreprise jeune et dynamique, rendant un service de qualité à des prix abordables.
                        Disponible et volontaire, je recommande fortement Simon et son équipe pour la création de vos vidéos.

                    </p>
                    <p className="person mt-4">Jordan Torres</p>
                </div>
            </div>
        </div>
    )
}

export default AvisAgence